import React from "react";
import { FormSelect } from "@jsq/ds/forms";
import { AccountTypeDropdownProps } from "./types";

export const AccountTypeDropdown: React.FC<AccountTypeDropdownProps> = ({
  name,
  accountTypes,
  placeholder = "Select account type",
  label,
  isFull = true,
}) => {
  return (
    <FormSelect
      name={name}
      full={isFull}
      placeholder={placeholder}
      data-cy={name}
      data-testid={name}
      label={label}
    >
      <FormSelect.Section>
        {accountTypes.map((type) => (
          <FormSelect.Option key={type.key} value={type.key}>
            {type.label}
          </FormSelect.Option>
        ))}
      </FormSelect.Section>
    </FormSelect>
  );
};
